// extracted by mini-css-extract-plugin
export default {"imageContainer":"R1-z","summaryPar":"S1-z","ratingCategories":"T1-z","reviewerInfo":"U1-z","reviewTypes":"V1-z","expanded":"W1-z"};